// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","boardrow":"App_boardrow__CLbO2","square":"App_square__P4Cih"};